import { AxiosRequestConfig } from 'axios';

// Function to get es_chat cookie
const getEsChatCookie = (): string | null => {
  const cookies = document.cookie.split(';');
  const esChatCookie = cookies.find(cookie => cookie.trim().startsWith('es_chat='));
  return esChatCookie ? esChatCookie.split('=')[1] : null;
};

// Function to redirect to login page
// const redirectToLogin = () => {
//   // Clear es_chat cookie
//   document.cookie = 'es_chat=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  
//   // Redirect to login page
//   window.location.href = '/signin';
// };

// Function to add es_chat cookie to axios config
export const addEsChatToConfig = (config: AxiosRequestConfig = {}): AxiosRequestConfig => {
  const esChatCookie = getEsChatCookie();
  
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(config.headers as Record<string, string>),
  };

  // Add es_chat cookie to Authorization header if it exists
  if (esChatCookie) {
    headers.Authorization = esChatCookie;
  }

  return {
    ...config,
    headers,
  };
};

// Function to handle axios errors without automatic logout
export const handleAxiosError = (error: any) => {
  if (error.response?.status === 401 || error.response?.status === 404) {
    // Don't automatically logout, just log the error
  }
  throw error;
};

// Function to auto-login using es_chat cookie
export const autoLoginWithEsChat = async () => {
  try {
    const esChatCookie = getEsChatCookie();
    
    if (!esChatCookie) {
      return null;
    }

    const response = await fetch('https://api.insightssystem.com/api:-4GSCDHb/auth/me', {
      method: 'GET',
      headers: {
        'Authorization': esChatCookie,
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      return {
        user_id: data.user_id,
        email: data.email,
        id: data.id
      };
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

// Example usage with axios:
// const config = addEsChatToConfig({ params: requestParams });
// const response = await axios.get(url, config);
// 
// Or in catch block:
// } catch (error) {
//   handleAxiosError(error);
// }
